module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@3x-b7a4690482c604689b81ff137cb7344d.png";